module.exports = __webpack_public_path__ + "img/MEA.c7cd2acc.jpg";